module.exports = __webpack_public_path__ + "img/form-follows-function.b4cc70e0.png";